import React, { useEffect, useState } from "react";
import AddUpdateCompanyDelegation from "./AddUpdateCustomerDelegation";
import useFullscreenToggle from "../../hooks/Screen/FullCloseScreen";
import { useFetchCompanyDelegationQuery } from "../../utils/customer/customerTaskTable";
import { getCompanyId } from "../../utils/utilityFunctions/localServices";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { useLocation } from "react-router-dom";
import AvatarName from "../UniversalComponents/AvatarName";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import { DELETE_ACCESS } from "../../utils/constants";
import { deleteData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import useRequireAuth from "../../utils/useRequireAuth";
import { getUserTokeData } from "../../utils/userSlice";
import { showLoader, hideLoader } from "../../utils/loaderSlice";
import DeleteIcon from "../../assets/images/icons/deleteIcon";
import ConfirmationDialogBox from "../UniversalComponents/ConfirmationDialogMulti";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ManageIcon from "../../assets/images/icons/ManageIcon";
import { ReactComponent as NoCompanyDelegation } from "../../assets/images/NoCompanyDelegation.svg";

const CompanyDelegation = ({ addCompanyID, TabSwitch }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editData, setEditData] = useState();
  const { isFullscreen, toggleFullscreen } = useFullscreenToggle();
  const [customer, setCustomer] = useState([]);
  const { token } = useRequireAuth();
  const location = useLocation();
  const dispatch = useDispatch();
  const companyLocalData = localStorage?.getItem("company_data");
  const [selectedDataToBeDeteted, setSelectedDataToBeDeleted] = useState(null);
  const [updateCounter, setUpdateCounter] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isMangeHovered, setIsMangeHovered] = useState(false);

  const parsedCompanyData = JSON.parse(companyLocalData);

  const {
    data: customerTableALL,
    refetch: refetchCustomerData,
    isFetching: companyDelegationLoading,
    isLoading: loadingCompanyDelegation,
    isError,
  } = useFetchCompanyDelegationQuery({
    token: token,
    pagination: `?company_id=${addCompanyID || getCompanyId()}`,
  });

  const handelRegenerat = () => {
    refetchCustomerData();
  };

  const onClose = () => {
    setIsPopupOpen(false);
    setEditData("");
  };

  const HoverCard = ({ name, emailID, mobile, handleCLick }) => {
    return (
      <div className="py-2 min-w-[17.78rem]">
        <div className="rounded-lg bg-white">
          <div className="border-b-2 space-y-2 pb-2">
            <div className="flex px-2 space-x-2">
              <div>
                <div className="">
                  <AvatarName
                    name={getInitials(name)}
                    size="small"
                    bgColor={"#E8ECF299"}
                    textColor={"#7C7C83"}
                    borderColor={"#ABABAC"}
                  />
                </div>
              </div>
              <div className="text-2999BC text-14">{name || "-"}</div>
            </div>

            <div className="flex px-2 space-x-2 my-2">
              <div className="w-5 text-center">
                <EmailIcon />
              </div>
              <div className="text-F16136 text-12">{emailID || "-"}</div>
            </div>

            <div className="flex px-2 space-x-2 my-2">
              <div className="w-5 text-center">
                <PhoneIcon />
              </div>
              <div className="text-F16136 text-12">{mobile || "-"}</div>
            </div>
          </div>
          {/* <div className="flex justify-end mt-2 me-5 text-12">
                <button className="text-blue-500" onClick={() => console.log("helllo")}>
                  Show more
                </button>
              </div> */}
        </div>
      </div>
    );
  };

  const handleDelete = async (item) => {
    const id = item?.customer_id;
    const url = `${DELETE_ACCESS}`;

    const payload = {
      email: item?.email,
      user_id: id,
      company_id: parsedCompanyData?.company_id,
      group_id: item?.group_id,
    };

    let response = await deleteData(url, token, payload, "POST");

    if (response.message === "Operation successful") {
      refetchCustomerData();
      dispatch(pushAlert({ message: "User deleted successfully", type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
    }
  };

  const handleDeleteGroupDialogConfirmation = async () => {
    setUpdateCounter((prevCounter) => prevCounter + 1);
    dispatch(
      pushAlert({
        type: "revert",
        message: "",
        visible: true,
        counter: updateCounter,
        onConfirm: () => {
          handleDelete(selectedDataToBeDeteted);
          setSelectedDataToBeDeleted(null);
        },
        onRevert: () => {
          setSelectedDataToBeDeleted(null);
        },
      })
    );
  };

  useEffect(() => {
    if (companyDelegationLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [companyDelegationLoading]);

  useEffect(() => {
    if (customerTableALL) {
      const { data, ...restData } = customerTableALL?.data;
      setCustomer(data);
    }
  }, [customerTableALL, refetchCustomerData, location.key]);

  useEffect(() => {
    if (location.key) {
      refetchCustomerData();
      dispatch(getUserTokeData());
    }
  }, [location.key]);

  return (
    <>
      <div className="profile w-full grow min-h-0" id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
        <div className={` flex flex-col h-full ${isFullscreen ? "bg-white h-full" : ""}`}>
          {customer && (
            <ReactTableComponent
              tablename={<TabSwitch />}
              // tablename={<p className="text-2C495D font-600 py-2">Company Delegation</p>}
              headers={[
                {
                  accessor_key: "user_name",
                  label: "User Name",
                  callingFunction: (item) => {
                    setIsPopupOpen(true);
                    setEditData(item);
                  },
                  tooltip: (data) => (
                    <HoverCard name={data?.data?.user_name} emailID={data?.data?.email} mobile={data?.data?.mobile} />
                  ),
                },
                {
                  accessor_key: "email",
                  label: "Email",
                },
                {
                  accessor_key: "department",
                  label: "Department",
                },
                {
                  accessor_key: "designation",
                  label: "Designation",
                },
                {
                  accessor_key: "reporting",
                  label: "Reporting",
                  callingFunction: () => console.log("Called Column Function"),
                  tooltip: (data) => (
                    <HoverCard
                      name={data?.data?.reporting}
                      emailID={data?.data?.manager_email}
                      mobile={data?.data?.manager_phone}
                    />
                  ),
                  // tooltip: (data) => console.log(data, "companydata"),
                },
                {
                  accessor_key: "access_type",
                  label: "Group",
                },
              ]}
              body={customer}
              isHyperLinkBold
              actionField={
                <div className="flex items-center gap-2">
                  <span
                    onClick={() => setIsPopupOpen(true)}
                    className="border border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                  >
                    <PlusIcon isActive={isPopupOpen} isHovered={isHovered} />
                  </span>

                  <span className="border border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent">
                    <ManageIcon isActive={""} isHovered={isMangeHovered} />
                  </span>
                </div>
              }
              actionColumn={(item) => {
                return (
                  <button
                    onClick={() => {
                      setSelectedDataToBeDeleted(item);
                    }}
                  >
                    <DeleteIcon color={"red"} size={18} />
                  </button>
                );
              }}
              apiStates={{
                body: {
                  isLoading: loadingCompanyDelegation,
                  isError: isError,
                },
              }}
              alternateDivs={{
                emptyData: (
                  <div className="w-full h-full flex justify-center items-center flex-col space-y-2">
                    <NoCompanyDelegation className="h-[300px] w-[300px]" />
                    <span className="text-[#000000] font-poppins font-500 text-14">
                      No company delegations is available
                    </span>
                  </div>
                ),
              }}
            />
          )}
        </div>
      </div>

      {isPopupOpen && (
        <AddUpdateCompanyDelegation
          isOpen={isPopupOpen}
          onClose={onClose}
          handleSubmitData={handelRegenerat}
          editData={editData}
        />
      )}

      <ConfirmationDialogBox
        onConfirm={() => {
          setSelectedDataToBeDeleted(null);
          handleDeleteGroupDialogConfirmation();
        }}
        open={selectedDataToBeDeteted}
        onClose={() => setSelectedDataToBeDeleted(null)}
        message={"Do you want to delete this group?"}
        iconVariant={"delete"}
        confirmVariant="delete"
        confirmText="Delete"
        cancelText="Cancel"
      />
    </>
  );
};

export default CompanyDelegation;
